<template>
  <!-- eslint-disable -->
  <div>
    <div v-if="this.multiple || this.multi" class="relative flex flex-col gap-2">
      <div v-for="(item, index) in value" :key="index" class="flex gap-2">
        <div
          v-if="prefix"
          class="absolute inset-y-0 flex items-center pointer-events-none left-0 pl-3.5"
          ref="inputPrefix"
        >
          <span>{{ prefix }}</span>
        </div>
        <div class="relative w-full">
          <div
            v-if="icon || inputType !== 'text'"
            class="absolute inset-y-0 flex items-center pr-3.5 pointer-events-none left-0 pl-3.5"
          >
            <i :class="getIconType()"></i>
          </div>
          <input
            ref="inputRef"
            v-model="value[index]"
            type="text"
            :minlength="min"
            :maxlength="max"
            :placeholder="computedPlaceholder"
            :class="inputClasses"
            :readonly="readonly"
            :data-key="index"
            :disabled="disabled"
            @change="$emit('change', $event.target.value)"
            @input="handleChange"
            @focus="$emit('focus')"
            @blur="$emit('blur')"
          />
          <p class="text-sm text-red-600 mt-2" v-if="errorMessage">{{ errorMessage }}</p>
          <div v-if="clearable && value[index]" class="absolute right-0 flex items-center pr-3.5 inset-y-0">
            <div class="bg-white text-color-gray-50" @click="clearInput(index)">
              <i class="ti ti-x"></i>
            </div>
          </div>
          <div v-if="loading" class="absolute inset-y-0 right-0 flex items-center pr-3.5 z-10">
            <div role="status">
              <svg
                aria-hidden="true"
                class="inline w-4 h-4 text-gray-200 animate-spin fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          </div>
        </div>
        <button @click="deleteValue(index)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px">
            <path
              d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div v-else>
      <div class="relative w-full">
        <div
          v-if="prefix"
          class="absolute inset-y-0 flex items-center pointer-events-none left-0 pl-3.5"
          style="z-index: 1"
          ref="inputPrefix"
        >
          <span>{{ prefix }}</span>
        </div>
        <div
          class="absolute inset-y-0 flex items-center pr-3.5 pointer-events-none left-0 pl-3.5"
          style="z-index: 1"
          v-if="icon || inputType !== 'text'"
        >
          <i :class="getIconType()"></i>
        </div>
        <input
          ref="inputRef"
          :minlength="min"
          :maxlength="max"
          v-model="modelValue"
          :placeholder="computedPlaceholder"
          :class="inputClasses"
          :readonly="readonly"
          :type="inputType !== 'address' ? inputType : 'text'"
          :disabled="disabled"
          @change="$emit('change', $event.target.value)"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
          @keyup="$emit('keyup', $event)"
          :style="{
            paddingLeft: prefixWidth > 0 ? prefixWidth + 5 + 'px' : null,
            paddingRight: sufixWidth > 0 ? sufixWidth + 5 + 'px' : null,
          }"
        />
        <p class="text-sm text-red-600 mt-2" v-if="errorMessage">{{ errorMessage }}</p>
        <div
          v-if="iconRight"
          class="absolute inset-y-0 flex items-center pr-3.5 pointer-events-none right-0 pl-3.5"
          style="z-index: 1"
        >
          <i :class="iconRight"></i>
        </div>
        <div
          v-if="sufix"
          class="absolute inset-y-0 flex items-center pr-3.5 pointer-events-none right-0 pl-3.5"
          style="z-index: 1"
          ref="inputSufix"
        >
          <span>{{ sufix }}</span>
        </div>
        <div v-if="clearable && value" class="absolute right-0 flex items-center pr-3.5 inset-y-0">
          <div class="text-color-gray-50 cursor-pointer text-sm" @click="clearInput()">
            <i class="ti ti-x"></i>
          </div>
        </div>
        <div v-if="loading" class="absolute inset-y-0 right-0 flex items-center pr-3.5 z-10">
          <div role="status">
            <svg
              aria-hidden="true"
              class="inline w-4 h-4 text-gray-200 animate-spin fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.multiple || this.multi" class="mt-3">
      <div
        class="inline-flex items-center gap-x-1.5 text-sm text-blue-600 decoration-2 hover:underline font-medium cursor-pointer"
        @click="addField()"
      >
        <svg
          class="w-3.5 h-3.5"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
          ></path>
        </svg>
        Додати поле
      </div>
    </div>
  </div>
</template>
<script>
import IMask from 'imask';
import filterElementMx from '@/components/form/mixins/vs-form-mx';

export default {
  mixins: [filterElementMx],
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'gray',
    },
    iconRight: {
      type: String,
      default: '',
    },
    max: {
      type: Number,
      default: 1000,
    },
    min: {
      type: Number,
      default: 0,
    },
    value: {
      type: [Array, String],
      default() {
        return this.multiple || this.multi ? [{ id: 0, value: '' }] : '';
      },
    },
    inputType: {
      type: String,
      default: 'text', // text, email, tel, address
    },
    pattern: {
      type: String,
      default: '',
    },
    inputStyle: {
      type: String,
      default: 'outlined', // filled, underline, borderless, outlined
    },
    prefix: {
      type: String,
      default: '',
    },
    sufix: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resizeObserver: null,
      prefixWidth: 0,
      sufixWidth: 0,
    };
  },
  computed: {
    inputClasses() {
      return [
        'vs-form-text transition-all block w-full rounded-md py-2 px-3 font-normal',
        { [`!text-${this.size}`]: this.size !== 'md' },
        { 'text-base': this.size === 'md' },
        { 'hover:cursor-not-allowed opacity-50': this.disabled },
        { 'bg-gray-100 border-transparent': this.inputStyle === 'filled' },
        { [`border-${this.color}-200`]: this.inputStyle === 'outlined' },
        { 'border-transparent': this.inputStyle === 'borderless' },
        {
          [`py-3 pe-0 ps-8 border-t-transparent border-b-2 border-x-transparent border-b-${this.color}-200 
            focus:border-t-transparent focus:border-x-transparent focus:border-b-blue-500 focus:ring-0 transition-none rounded-none`]:
            this.inputStyle === 'underline',
        },
        { 'pl-10': this.icon || this.inputType !== 'text' },
        { 'pr-10': this.iconRight },
        { 'border-red-500': this.error },
      ];
    },
    computedPlaceholder() {
      if (this.placeholder.length) {
        return this.placeholder;
      }

      if (this.inputType === 'tel' && !this.placeholder.length) {
        return '+38(000) 000-00-00';
      }

      if (this.inputType === 'email' && !this.placeholder.length) {
        return 'yourplaceholder@gmail.com';
      }

      return 'Введіть текст...';
    },
    computedPattern() {
      if (this.inputType === 'tel') {
        return '+{38}(000)000-00-00';
      }

      if (this.inputType === 'email') {
        return /^\S*@?\S*$/;
      }

      return this.pattern;
    },
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  async mounted() {
    if (this.autofocus) {
      this.$refs?.inputRef?.focus();
    }

    this.resizeObserver = new ResizeObserver(this.onResize);
    if (this.prefix) this.resizeObserver?.observe(this.$refs?.inputPrefix);
    if (this.sufix) this.resizeObserver?.observe(this.$refs?.sufixPrefix);
    this.onResize();

    if (this.inputType === 'tel' || this.inputType === 'email') {
      const maskOptions = {
        mask: this.computedPattern,
      };

      IMask(this.$refs.inputRef, maskOptions);
    }

    if ((this.multiple || this.multi) && (!this.value.length || !this.value)) {
      this.$emit('input', ['']);
    }
  },
  methods: {
    handleChange() {
      this.$emit('input', this.value);
    },
    clearInput(index) {
      if (this.multiple || this.multi) {
        const updatedFields = [...this.value];
        updatedFields[index] = '';
        // eslint-disable-next-line
        this.value = updatedFields;
        this.$emit('change', updatedFields);
        this.handleChange();
      } else {
        // eslint-disable-next-line
        this.value = '';
        this.handleChange();
        this.$emit('change', '');
      }
    },
    deleteValue(index) {
      if (this.value.length > 1) {
        // eslint-disable-next-line
        this.value = this.value.filter((input, rowIndex) => rowIndex !== index);
        this.handleChange();
      }
    },
    addField() {
      // eslint-disable-next-line
      this.value = this.value.concat('');
      this.handleChange();
    },
    onResize() {
      if (this.prefix) {
        this.prefixWidth = this.$refs?.inputPrefix?.offsetWidth;
      }

      if (this.sufix) {
        this.sufixWidth = this.$refs?.inputSufix?.offsetWidth;
      }
    },
    getIconType() {
      switch (this.inputType) {
        case 'tel':
          return 'ti ti-phone';

        case 'email':
          return 'ti ti-mail';

        case 'address':
          return 'ti ti-home';

        default:
          return this.icon;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vs-form-text:focus {
  &:focus {
    box-shadow: none;
    outline: none;
  }
}

[type='text']:focus,
[type='email']:focus,
[type='url']:focus,
[type='password']:focus,
[type='number']:focus,
[type='date']:focus,
[type='datetime-local']:focus,
[type='month']:focus,
[type='search']:focus,
[type='tel']:focus,
[type='time']:focus,
[type='week']:focus {
  box-shadow: none;
  outline: none;
}
</style>
